// imports
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { IActionItem } from '../../../common/types';

// interfaces / types / consts
interface DropdownProps {
  item: IActionItem;
  currentTab: string;
  onItemClicked: (url: string, key: string) => void;
}

// exports
function Dropdown(props: DropdownProps): JSX.Element {
  const {
    currentTab,
    onItemClicked,
    item: {
      key, display, icon, iconActive, children
    }
  } = props;
  // hooks configuration
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    if (children?.find((child) => child.key === currentTab)) { setShow(true); } else { setShow(false); }
  }, [currentTab, children]);
  useEffect(() => {
    if (children?.find((child) => child.key === currentTab) && !show) { setIsActive(true); } else { setIsActive(false); }
  }, [show, currentTab, children]);
  // render
  return (
    <div className="sidebar-dropdown">
      <li className={clsx(isActive && 'active')}>
        <button type="button" onClick={() => setShow((prev) => !prev)}>
          <div className="heading">
            <img src={isActive ? iconActive : icon} alt="icon" />
            <div className="li-text">{display || key}</div>
            <span className={clsx('triangle', show && 'rotate', isActive && 'active')} />
          </div>
        </button>
      </li>
      {show && (
        <ul>
          {children?.map((child) => {
            const { url, key: childKey, display: childDisplay } = child;
            return (
              <li key={childKey} className={clsx(childKey === currentTab && 'active')}>
                <button type="button" onClick={() => { if (url) { onItemClicked(url, childKey); } }}>
                  <span className="diamond" />
                  <div className="li-text">{childDisplay || childKey}</div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default Dropdown;
